export const formatNumber = (number, c) => {
    const currency = c === ""? "GBP": c;
    return new Intl.NumberFormat('en-en', { style: 'currency', currency: currency }).format(number);
}